import React from "react";
import { useNavigate } from "react-router-dom";

const DeleteAccountPage = () => {

  return (
    <div className="delete-page">
      <div className="delete-card">
        <div className="warning-icon">⚠</div>
        <h2>Delete Account</h2>
        <p className="warning-text">
          Account deletion is not available through our web app.  
          Please follow the steps below to delete your account using our official mobile app.
        </p>

        <div className="steps">
          <div className="step">
            <span className="step-number">1</span>
            <p>
              Install the <strong>BBarna</strong> app from{" "}
                Google Play Store
            </p>
          </div>

          <div className="step">
            <span className="step-number">2</span>
            <p>Login to the app using your registered account credentials.</p>
          </div>

          <div className="step">
            <span className="step-number">3</span>
            <p>Go to profile.</p>
          </div>

          <div className="step">
            <span className="step-number">4</span>
            <p>Press on <strong>Delete Account</strong> and follow the confirmation steps.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPage;
